module.exports = __webpack_public_path__ + "img/yaopinpandiandan.b278e2b4.png";